'use strict';

var toastr = require('toastr');
toastr.options.preventDuplicates = true;
var ExceptionHandlerToastrDecorator = function ExceptionHandlerToastrDecorator($delegate, exceptionHandler) {
  return function (exception, cause) {
    if (typeof exception === 'string' || exception instanceof String) {
      exception = new Error(exception);
    }
    var appErrorPrefix = exceptionHandler.config.appErrorPrefix;
    var errorData = {
      exception: exception,
      cause: cause
    };
    toastr.error(appErrorPrefix + exception.message, errorData);
    $delegate(exception, cause);
  };
};
ExceptionHandlerToastrDecorator.$inject = ['$delegate', 'exceptionHandler'];
module.exports = ExceptionHandlerToastrDecorator;